import styled from "styled-components";
import BgGradient2 from "./assets/10.png";

export const IndexChatComponentMainDiv = styled.div`
  width: 100%;
  flex: 1;
  background-size: cover;
  background: rgb(0, 152, 243);

  background-repeat: no-repeat;
  border-radius: 12px;
  background-image: url(${BgGradient2});
  
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex: 1;
    flex-direction: column;
    gap: 24px;
    padding: 50px 0 0 0;
    height: 316px;
    border-radius: 16px;
  }
  .index-chat-human-chat-holder,
  .index-chat-human-chat-holder-reverse {
    display: flex;

    width: 75%;
    align-items: center;
    justify-content: flex-end;
    border-radius: 16px;
    > div {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
  .index-chat-human-chat-holder-reverse {
    > div {
      flex-direction: row-reverse;
      flex: 1;
    }
  }
  .index-chat-chatbox-contain {
    border-radius: 16px;
    backdrop-filter: blur(2px);

    border: 1px solid rgba(255, 255, 255, 0.08);
    padding: 8px 1.4rem;
    flex: 1;
    display: flex;
  }
  .index-chat-chatbox-action-container {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 14px;
  }

  .index-chat-human-chat-text-holder {
    display: flex;
    align-items: center;

    > p {
      padding: 0;
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.2em;
      font-family: Inter, "Inter Placeholder", sans-serif;
    }
    > h3 {
      margin: 0;
      padding: 8px 0 0 0;
      font-size: 18px;
      font-weight: 600;
    }
  }
  .index-chat-human-chat-image-holder,
  .index-chat-human-chat-image-holder-invinsible {
    width: 36px;
    height: 36px;
    border-radius: 100%;
    padding: 1px;

    background: rgba(255, 255, 255, 0.08);
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 100%;
    }
  }
  .index-chat-human-chat-image-holder-invinsible {
    width: 18px;
    height: 0px;
    opacity: 0;
    padding: 1px;
  }
  .index-chat-human-chat-action-holder {
    display: flex;
    width: 100%;
    flex: 1;
    > div {
      display: flex;
      gap: 8px;
      flex: 1;
      align-items: center;
      border: 1px solid rgba(255, 255, 255, 0.08);
      backdrop-filter: blur(5px);
      border-radius: 12px;
      padding: 0 8px;
    }
    .file-name {
      flex: 1;
      width: 1px;
      max-width: 100%;
      white-space: noWrap;
      overflow: hidden;
      text-oveflow: hidden;
      display: flex;
      > div {
        text-overflow: ellipsis;

        overflow: hidden;
        > p {
          padding: 0;
          font-weight: 500;
          text-overflow: ellipsis;

          overflow: hidden;
          font-size: 16px;
        }
      }
    }
  }
  .index-chat-icon {
    > svg {
      fill: white;
      width: 24px;
      height: 24px;
    }
  }
  .index-chat-checkbox {
    width: 24px;
    height: 24px;
    border: 3px solid rgba(255, 255, 255, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    > svg {
      fill: #44ff00ff;
      width: 14px;
      height: 14px;
    }
  }
`;
